module.exports = __webpack_public_path__ + "static/media/gold-white-triangle.152e3efc.jpg";